import { render, staticRenderFns } from "./common-table.vue?vue&type=template&id=0f110436&scoped=true&"
import script from "./common-table.vue?vue&type=script&lang=ts&"
export * from "./common-table.vue?vue&type=script&lang=ts&"
import style0 from "./common-table.vue?vue&type=style&index=0&id=0f110436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f110436",
  null
  
)

export default component.exports